import { useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// EndTest moved to parent; handlers only submit and signal parent now
import { processAudioUpload } from "../utils/audioProcessing";
import { processQuestionSubmission } from "../utils/questionProcessing";

export const useSpeakingSubmission = ({
  quest,
  questData,
  recordingState,
  questionsTime,
  commulative,
  setCommulative,
  MockTestAttemptID,
  ExamId,
  step,
  totalQuestions,
  setStep,
  setNetworkError,
  resetQuestionTimer,
  audioRef,
  setClicked,
  stopStopwatch,
  endTestAndTimeout
}) => {
  const navigate = useNavigate();
  const submittingRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNext = useCallback(() => {
    if (recordingState.disabledButton) return;
    if (audioRef.current) audioRef.current.pause();

    setClicked((prev) => !prev);
    recordingState.setDisabledButton(true);
    stopStopwatch();
  }, [recordingState.disabledButton, audioRef, setClicked, recordingState.setDisabledButton, stopStopwatch]);

  const handleExit = useCallback(() => {
    if (audioRef.current) audioRef.current.pause();
    navigate("/MockTest");
  }, [audioRef, navigate]);

  const handleQuestionSubmission = useCallback(async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setIsSubmitting(true);
    setNetworkError(false);
    const timeSpent = Math.floor(questionsTime / 1000);
    const currentCumulative = parseInt(commulative, 10) || 0;
    const updatedCommulative = currentCumulative + timeSpent;
    try {
      const audioUrl = await processAudioUpload(recordingState.recordedBlobFile);
      if (typeof audioUrl !== "string" || !audioUrl.trim()) {
        throw new Error("Recording upload failed");
      }
      const res = await processQuestionSubmission({
        quest,
        questData,
        transcript: recordingState.transcript,
        timeSpent,
        commulative: updatedCommulative,
        MockTestAttemptID,
        ExamId,
        audioUrl
      });
      if (!res || res.error) throw new Error("Answer save failed");
    } catch (error) {
      setNetworkError(true);
      return;
    } finally {
      submittingRef.current = false;
      setIsSubmitting(false);
    }

    setCommulative(updatedCommulative);
    resetQuestionTimer();
    recordingState.setRecordedAudioFile(null);
    if (quest) quest.IsAttempted = true;
    if (step === totalQuestions && typeof endTestAndTimeout === 'function') {
      endTestAndTimeout().then(() => {});
    } else {
      setStep((prev) => (prev < totalQuestions ? prev + 1 : prev));
    }
    
  }, [
    quest,
    questData,
    recordingState.recordedBlobFile,
    recordingState.transcript,
    recordingState.setRecordedAudioFile,
    questionsTime,
    commulative,
    setCommulative,
    MockTestAttemptID,
    ExamId,
    step,
    totalQuestions,
    setNetworkError,
    setStep,
    endTestAndTimeout,
    resetQuestionTimer
  ]);

  return {
    handleNext,
    handleExit,
    handleQuestionSubmission,
    isSubmitting
  };
};
